import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

/**
 * El ⓘ de un bloque que muestra un campo con advertencia (`FIELD_CAVEATS`, card ctbIdOOc): hoy, un
 * desglose aproximado de LinkedIn por país o región, cuya suma no coincide con el Total.
 *
 * A diferencia del ⚠ de eventos (`PanelEventsWarning`) no pide nada: es información, por eso el
 * ícono es el ⓘ gris del Tablero y no el triángulo rojo. Y a diferencia de aquél, lo ve también el
 * cliente del portal: el dato aproximado lo lee él. Se alcanza con teclado (`tabIndex` + el
 * `:focus-visible` de `.info-icon-container`).
 */
export function PanelCaveatsWarning({codes, opensTo = 'right'}) {
    const {t} = useTranslation();
    if (!codes || !codes.length) return null;
    const texts = codes.map((code) => t(`informes.caveats.${code}`));
    return (
        <span className="info-icon-container -stronger inf-caveat-warning" tabIndex={0}
              aria-label={texts.join(' ')} data-testid="inf-caveat-warning">
            <FaIcon iconName="info-circle"/>
            <div className={`warning-tooltip ${opensTo === 'left' ? '-below-right' : '-below-left'}`}>
                <div className="warning-tooltip-body">
                    {texts.map((text, index) => (
                        <p key={codes[index]} className="warning-tooltip-text">{text}</p>
                    ))}
                </div>
            </div>
        </span>
    );
}
